import React from 'react';
import Navbar from './components/Navbar';
import './App.css';
import Home from './components/pages/Home';
import Footer from './components/footer/Footer';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Curriculum from "./components/pages/Curriculum";
import ObraDisponible from "./components/pages/ObraDisponible";
import Contacto from "./components/pages/Contacto";
import GaleriaVirtual from "./components/pages/GaleriaVirtual";
import Lenguaje from "./components/pages/Lenguaje";
import 'bootstrap/dist/css/bootstrap.min.css';


function App() {
  return (
    <Router>
      <Navbar></Navbar>
      <Switch>
        <Route path='/' exact component={Home} />
        <Route path='/curriculum' component={Curriculum} />
        <Route path='/obra-disponible' component={ObraDisponible} />
        <Route path='/contacto' component={Contacto} />
        <Route path='/galeria-virtual' component={GaleriaVirtual} />
        <Route path='/lenguaje' component={Lenguaje} />
      </Switch>
      {/* <Header></Header> */}
      <Footer></Footer>
    </Router>
  );
}

export default App;
